<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
            <!-- Progress bar -->
            <div v-if="progressBar == true" class="col-3 ms-auto d-print-none d-flex align-items-center" id="progressBar">
                <span class="small me-3 w-50 text-end">{{ percentageComplete }}% Complete</span>
                <b-progress class="w-50" :value="currentStep" :max="maxStep" animated></b-progress>
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-resident" action="residents/store" class="add-resident add-record">
            <div class="card" v-if="currentStep == 1" title="Profile Information">
                <div class="card-header">
                    <h3 class="card-title">Personal Information</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Given Name</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="given-name"
                                            placeholder="Ex. John"
                                            v-model="step[0].givenName"
                                            :class="{
                                                'is-invalid': v$.step[0].givenName.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[0].givenName.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Preferred Name</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="preferred-name"
                                            placeholder="Ex. Johny"
                                            v-model="step[0].preferredName"
                                            :class="{
                                                'is-invalid': v$.step[0].preferredName.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[0].preferredName.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Surname</div>
                                <input type="text" class="form-control" name="surname" placeholder="Ex. Doe" v-model="step[0].surname" :class="{'is-invalid': v$.step[0].surname.$invalid}" />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].surname.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">NHI No.</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="nhi-number"
                                    placeholder="Ex. ABC1234"
                                    v-model="step[0].NHINumber"
                                    :class="{
                                        'is-invalid': v$.step[0].NHINumber.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].NHINumber.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Date of Birth</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="date-of-birth"
                                    placeholder="01-02-1975"
                                    v-model="step[0].dateOfBirth"
                                    :class="{'is-invalid': v$.step[0].dateOfBirth.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].dateOfBirth.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Place of Birth</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="birth-place"
                                    placeholder="Name of city"
                                    v-model="step[0].birthPlace"
                                    :class="{
                                        'is-invalid': v$.step[0].birthPlace.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].birthPlace.$invalid}">Invalid feedback</div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Marital Status</div>
                                <select
                                    class="form-select"
                                    name="marital-status"
                                    v-model="step[0].maritalStatus"
                                    :class="{
                                        'is-invalid': v$.step[0].maritalStatus.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in maritalStatusOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].maritalStatus.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Gender</div>
                                <label v-for="option in genderOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="gender" :value="option" v-model="step[0].gender" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].gender.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Iwi</div>
                                <input type="text" class="form-control" name="iwi" placeholder="Ex. Ngāpuhi" v-model="step[0].iwi" :class="{'is-invalid': v$.step[0].iwi.$invalid}" />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].iwi.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Ethnicity</div>
                                <select
                                    class="form-select"
                                    name="ethnicity"
                                    v-model="step[0].ethnicity"
                                    :class="{
                                        'is-invalid': v$.step[0].ethnicity.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in ethnicityOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].ethnicity.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].ethnicity === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="ethnicity-other"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].ethnicityOther"
                                        :class="{
                                            'is-invalid': v$.step[0].ethnicityOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].ethnicityOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Religion</div>
                                <select
                                    class="form-select"
                                    name="religion"
                                    v-model="step[0].religion"
                                    :class="{
                                        'is-invalid': v$.step[0].religion.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in religionOptions" :value="option">
                                        {{ option }}
                                        <span v-if="option === 'Christian'">(Catholic, Protestant & all other Christian denomination)</span>
                                    </option>
                                </select>

                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].religion.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].religion === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="religion-other"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].religionOther"
                                        :class="{
                                            'is-invalid': v$.step[0].religionOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].religionOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3" v-if="this.operation == 'update'">
                                <div class="form-label">Profile Photo</div>
                                <div class="d-flex align-items-center">
                                    <span class="avatar avatar-xl rounded-circle" v-bind:style="{backgroundImage: `url('${photo}')`}"></span>
                                    <a :href="editPhotoLink" class="ms-2">Update Photo</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="invisible">Save and continue later</a>
                    </p>
                    <a href="#" class="btn btn-primary" @click="onClickNext">Next</a>
                </div>
            </div>

            <div class="card" v-if="currentStep == 2" title="Admission Details">
                <div class="card-header">
                    <h3 class="card-title">Admission Details</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Admission Date</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="admission-date"
                                    placeholder="01-01-1970"
                                    v-model="step[1].admissionDate"
                                    :class="{
                                        'is-invalid': v$.step[1].admissionDate.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].admissionDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Room No.</div>
                                <select
                                    class="form-select"
                                    name="room-id"
                                    v-model="step[1].roomID"
                                    :class="{
                                        'is-invalid': v$.step[1].roomID.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in roomOptions" :value="option.id">
                                        {{ option.name }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].roomID.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Admitted From</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="admitted-from"
                                    placeholder="Ex. Hospital or Location"
                                    v-model="step[1].admittedFrom"
                                    :class="{
                                        'is-invalid': v$.step[1].admittedFrom.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].admittedFrom.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Referred by</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="referred-by"
                                    placeholder="Ex. John Doe"
                                    v-model="step[1].referredBy"
                                    :class="{
                                        'is-invalid': v$.step[1].referredBy.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].referredBy.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Assessment Date</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="assessment-date"
                                    placeholder="01-01-1970"
                                    v-model="step[1].assessmentDate"
                                    :class="{
                                        'is-invalid': v$.step[1].assessmentDate.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].assessmentDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Assessed by</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="assessed-by"
                                            placeholder="Ex. John Doe"
                                            v-model="step[1].assessedBy"
                                            :class="{
                                                'is-invalid': v$.step[1].assessedBy.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].assessedBy.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Phone</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="assessed-by-phone"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[1].assessedByPhone"
                                            :class="{
                                                'is-invalid': v$.step[1].assessedByPhone.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].assessedByPhone.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Social Worker</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="social-worker"
                                            placeholder="Ex. John Doe"
                                            v-model="step[1].socialWorker"
                                            :class="{
                                                'is-invalid': v$.step[1].socialWorker.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].socialWorker.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Phone</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="social-worker-phone"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[1].socialWorkerPhone"
                                            :class="{
                                                'is-invalid': v$.step[1].socialWorkerPhone.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].socialWorkerPhone.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Previous GP</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="previous-gp"
                                            placeholder="Ex. John Doe"
                                            v-model="step[1].previousGP"
                                            :class="{
                                                'is-invalid': v$.step[1].previousGP.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].previousGP.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Phone</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="previous-gp-phone"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[1].previousGPPhone"
                                            :class="{
                                                'is-invalid': v$.step[1].previousGPPhone.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].previousGPPhone.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">House GP</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="house-gp"
                                            placeholder="Ex. John Doe"
                                            v-model="step[1].houseGP"
                                            :class="{
                                                'is-invalid': v$.step[1].houseGP.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].houseGP.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Phone</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="house-gp-phone"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[1].houseGPPhone"
                                            :class="{
                                                'is-invalid': v$.step[1].houseGPPhone.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].houseGPPhone.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Resuscitation</div>
                                <label v-for="option in yesNoOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[1].resuscitation" name="resuscitation" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].resuscitation.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 3" title="Enduring Power of Attorney">
                <div class="card-header">
                    <h3 class="card-title">Enduring Power of Attorney</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Property</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name-property-epoa"
                                    placeholder="Full name of property EPOA"
                                    v-model="step[2].namePropertyEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].namePropertyEPOA.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].namePropertyEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Relationship</div>
                                <select
                                    class="form-select"
                                    name="relationship-property-epoa"
                                    v-model="step[2].relationshipPropertyEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].relationshipPropertyEPOA.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in relationshipOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].relationshipPropertyEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3" v-if="step[2].relationshipPropertyEPOA == 'Other'">
                                <div class="form-label">Other</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="relationship-property-epoa-other"
                                    placeholder="Other"
                                    v-model="step[2].relationshipPropertyEPOAOther"
                                    :class="{
                                        'is-invalid': v$.step[2].relationshipPropertyEPOAOther.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].relationshipPropertyEPOAOther.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="address-property-epoa"
                                    placeholder="Address"
                                    v-model="step[2].addressPropertyEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].addressPropertyEPOA.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].addressPropertyEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Home phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="phone-property-epoa"
                                            placeholder="Ex. 01234567890"
                                            v-model="step[2].phonePropertyEPOA"
                                            :class="{
                                                'is-invalid': v$.step[2].phonePropertyEPOA.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[2].phonePropertyEPOA.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Mobile phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="mobile-property-epoa"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[2].mobilePropertyEPOA"
                                            :class="{
                                                'is-invalid': v$.step[2].mobilePropertyEPOA.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[2].mobilePropertyEPOA.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Email Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="email-property-epoa"
                                    placeholder="Ex. johndoe@mail.com"
                                    v-model="step[2].emailPropertyEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].emailPropertyEPOA.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].emailPropertyEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Welfare</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name-welfare-epoa"
                                    placeholder="Full name of welfare EPOA"
                                    v-model="step[2].nameWelfareEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].nameWelfareEPOA.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].nameWelfareEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Relationship</div>
                                <select
                                    class="form-select"
                                    name="relationship-welfare-epoa"
                                    v-model="step[2].relationshipWelfareEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].relationshipWelfareEPOA.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in relationshipOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].relationshipWelfareEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>


                            <div class="mb-3" v-if="step[2].relationshipWelfareEPOA == 'Other'">
                                <div class="form-label">Other</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="relationship-welfare-epoa-other"
                                    placeholder="Other"
                                    v-model="step[2].relationshipWelfareEPOAOther"
                                    :class="{
                                        'is-invalid': v$.step[2].relationshipWelfareEPOAOther.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].relationshipWelfareEPOAOther.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="address-welfare-epoa"
                                    placeholder="Address"
                                    v-model="step[2].addressWelfareEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].addressWelfareEPOA.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].addressWelfareEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Home phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="phone-welfare-epoa"
                                            placeholder="Ex. 01234567890"
                                            v-model="step[2].phoneWelfareEPOA"
                                            :class="{
                                                'is-invalid': v$.step[2].phoneWelfareEPOA.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[2].phoneWelfareEPOA.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Mobile phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="mobile-welfare-epoa"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[2].mobileWelfareEPOA"
                                            :class="{
                                                'is-invalid': v$.step[2].mobileWelfareEPOA.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[2].mobileWelfareEPOA.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Email Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="email-welfare-epoa"
                                    placeholder="Ex. johndoe@mail.com"
                                    v-model="step[2].emailWelfareEPOA"
                                    :class="{
                                        'is-invalid': v$.step[2].emailWelfareEPOA.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].emailWelfareEPOA.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 4" title="Next of kin or Agent(s) / Authorized Person(s)">
                <div class="card-header">
                    <h3 class="card-title">Next of kin or Agent(s) / Authorized Person(s)</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Kin #1</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name-kin1"
                                    placeholder="Full name of kin #1"
                                    v-model="step[3].nameKin1"
                                    :class="{
                                        'is-invalid': v$.step[3].nameKin1.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].nameKin1.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Relationship</div>
                                <select
                                    class="form-select"
                                    name="relationship-kin1"
                                    v-model="step[3].relationshipKin1"
                                    :class="{
                                        'is-invalid': v$.step[3].relationshipKin1.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in relationshipOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[3].relationshipKin1.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>


                            <div class="mb-3" v-if="step[3].relationshipKin1 == 'Other'">
                                <div class="form-label">Other</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="relationship-kin1-other"
                                    placeholder="Other"
                                    v-model="step[3].relationshipKin1Other"
                                    :class="{
                                        'is-invalid': v$.step[3].relationshipKin1Other.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[3].relationshipKin1Other.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="address-kin1"
                                    placeholder="Address"
                                    v-model="step[3].addressKin1"
                                    :class="{
                                        'is-invalid': v$.step[3].addressKin1.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[3].addressKin1.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Home phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="phone-kin1"
                                            placeholder="Ex. 01234567890"
                                            v-model="step[3].phoneKin1"
                                            :class="{
                                                'is-invalid': v$.step[3].phoneKin1.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[3].phoneKin1.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Mobile phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="mobile-kin1"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[3].mobileKin1"
                                            :class="{
                                                'is-invalid': v$.step[3].mobileKin1.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[3].mobileKin1.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Email Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="email-kin1"
                                    placeholder="Ex. johndoe@mail.com"
                                    v-model="step[3].emailKin1"
                                    :class="{
                                        'is-invalid': v$.step[3].emailKin1.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].emailKin1.$invalid}">Invalid feedback</div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Kin #2</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name-kin2"
                                    placeholder="Full name of kin #2"
                                    v-model="step[3].nameKin2"
                                    :class="{
                                        'is-invalid': v$.step[3].nameKin2.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].nameKin2.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Relationship</div>
                                <select
                                    class="form-select"
                                    name="relationship-kin2"
                                    v-model="step[3].relationshipKin2"
                                    :class="{
                                        'is-invalid': v$.step[3].relationshipKin2.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in relationshipOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[3].relationshipKin2.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3" v-if="step[3].relationshipKin2 == 'Other'">
                                <div class="form-label">Other</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="relationship-kin2-other"
                                    placeholder="Other"
                                    v-model="step[3].relationshipKin2Other"
                                    :class="{
                                        'is-invalid': v$.step[3].relationshipKin2Other.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[3].relationshipKin2Other.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>                            

                            <div class="mb-3">
                                <div class="form-label">Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="address-kin2"
                                    placeholder="Address"
                                    v-model="step[3].addressKin2"
                                    :class="{
                                        'is-invalid': v$.step[3].addressKin2.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[3].addressKin2.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

     
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Home phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="phone-kin2"
                                            placeholder="Ex. 01234567890"
                                            v-model="step[3].phoneKin2"
                                            :class="{
                                                'is-invalid': v$.step[3].phoneKin2.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[3].phoneKin2.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Mobile phone #</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="mobile-kin2"
                                            placeholder="Ex. 07123456789"
                                            v-model="step[3].mobileKin2"
                                            :class="{
                                                'is-invalid': v$.step[3].mobileKin2.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[3].mobileKin2.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Email Address</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="email-kin2"
                                    placeholder="Ex. johndoe@mail.com"
                                    v-model="step[3].emailKin2"
                                    :class="{
                                        'is-invalid': v$.step[3].emailKin2.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].emailKin2.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 5" title="Account Manager">
                <div class="card-header d-flex align-items-center">
                    <h3 class="my-0">Account Manager</h3>
                    <span
                        class="form-help ms-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-html="true"
                        data-bs-content="<p>Lorem ipsum dolor sit amet consectetur. Short text description</p>"
                    >
                        ?
                    </span>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Name</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name-account-manager"
                                    placeholder="Full name of account manager"
                                    v-model="step[4].nameAccountManager"
                                    :class="{
                                        'is-invalid': v$.step[4].nameAccountManager.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].nameAccountManager.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Community card number</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="community-card-number"
                                    placeholder="Community card number"
                                    v-model="step[4].communityCardNumber"
                                    :class="{
                                        'is-invalid': v$.step[4].communityCardNumber.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].communityCardNumber.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Expiry Date</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="community-card-expiry-date"
                                    placeholder="01-01-1970"
                                    v-model="step[4].communityCardExpiryDate"
                                    :class="{
                                        'is-invalid': v$.step[4].communityCardExpiryDate.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].communityCardExpiryDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Is resident sectioned under the mental health act</div>
                                <label v-for="option in yesNoOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[4].sectionedUnderMentalHealth" name="sectioned-under-mental-health" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].sectionedUnderMentalHealth.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Funeral Arrangements</div>
                                <label v-for="option in funeralArrangementOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[4].funeralArrangement" name="funeral-arrangement" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].funeralArrangement.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Funeral Director</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name-funeral-director"
                                    placeholder="Full name of funeral director"
                                    v-model="step[4].nameFuneralDirector"
                                    :class="{
                                        'is-invalid': v$.step[4].nameFuneralDirector.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].nameFuneralDirector.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Special Requirements</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="special-requirements"
                                    placeholder="Special requirements"
                                    v-model="step[4].specialRequirements"
                                    :class="{
                                        'is-invalid': v$.step[4].specialRequirements.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].specialRequirements.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Arrangements to be made</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="arrangements-to-be-made"
                                    placeholder="Arrangements to be made"
                                    v-model="step[4].arrangementsToBeMade"
                                    :class="{
                                        'is-invalid': v$.step[4].arrangementsToBeMade.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].arrangementsToBeMade.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3" v-if="this.operation != 'store'">
                                <div class="form-label">Discharge date</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="discharge-date"
                                    placeholder="01-01-1970"
                                    v-model="step[4].dischargeDate"
                                    :class="{
                                        'is-invalid': v$.step[4].dischargeDate.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].dischargeDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3" v-if="this.operation != 'store'">
                                <div class="form-label">Discharge to</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="discharge-to"
                                    placeholder="Discharge to"
                                    v-model="step[4].dischargeTo"
                                    :class="{
                                        'is-invalid': v$.step[4].dischargeTo.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].dischargeTo.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Medical Notes Transferred</div>
                                <label v-for="option in yesNoOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[4].medicalNotesTransferred" name="medical-notes-transferred" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].medicalNotesTransferred.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Relevant pages copied and archived</div>
                                <label v-for="option in yesNoOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[4].relevantPagesCopiedArchived" name="relevant-pages-copied-archived" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[4].relevantPagesCopiedArchived.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 6" title="Medical Data/History">
                <div class="card-header d-flex align-items-center">
                    <h3 class="card-title">Medical Data/History</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Previous Medical History</div>
                                <textarea
                                    rows="5"
                                    class="form-control"
                                    placeholder="Description"
                                    spellcheck="false"
                                    name="previous-medical-history"
                                    v-model="step[5].previousMedicalHistory"
                                    :class="{
                                        'is-invalid': v$.step[5].previousMedicalHistory.$invalid,
                                    }"
                                ></textarea>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[5].previousMedicalHistory.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Current Medical Problems</div>
                                <textarea
                                    rows="5"
                                    class="form-control"
                                    placeholder="Description"
                                    value=""
                                    spellcheck="false"
                                    name="current-medical-problems"
                                    v-model="step[5].currentMedicalProblems"
                                    :class="{
                                        'is-invalid': v$.step[5].currentMedicalProblems.$invalid,
                                    }"
                                ></textarea>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[5].currentMedicalProblems.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Medication on Admission</div>
                                <textarea
                                    rows="5"
                                    class="form-control"
                                    placeholder="Description"
                                    value=""
                                    spellcheck="false"
                                    name="medication-on-admission"
                                    v-model="step[5].medicationOnAdmission"
                                    :class="{
                                        'is-invalid': v$.step[5].medicationOnAdmission.$invalid,
                                    }"
                                ></textarea>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[5].medicationOnAdmission.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Allergies</div>
                                <textarea
                                    rows="5"
                                    class="form-control"
                                    placeholder="Description"
                                    value=""
                                    spellcheck="false"
                                    name="allergies"
                                    v-model="step[5].allergies"
                                    :class="{
                                        'is-invalid': v$.step[5].allergies.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].allergies.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 7" title="Baseline Observation">
                <div class="card-header">
                    <h3 class="card-title">Baseline Observation</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-label">Height (cm)</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="height"
                                            placeholder="Ex. 180"
                                            v-model="step[6].height"
                                            :class="{
                                                'is-invalid': v$.step[6].height.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[6].height.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-label">Weight (kg)</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="weight"
                                            placeholder="Ex. 80"
                                            v-model="step[6].weight"
                                            :class="{
                                                'is-invalid': v$.step[6].weight.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[6].weight.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-label">Blood Pressure</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="blood-pressure"
                                            placeholder="Ex. 120"
                                            v-model="step[6].bloodPressure"
                                            :class="{
                                                'is-invalid': v$.step[6].bloodPressure.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[6].bloodPressure.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-label">&nbsp;</div>
                                        <div class="d-flex align-items-center">
                                            <span>/</span>
                                            <input
                                                type="text"
                                                class="form-control ms-2"
                                                name="blood-pressure-over"
                                                placeholder="Ex. 80"
                                                v-model="step[6].bloodPressureOver"
                                                :class="{
                                                    'is-invalid': v$.step[6].bloodPressureOver.$invalid,
                                                }"
                                            />
                                        </div>
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[6].bloodPressureOver.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Pulse Rate (bpm)</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="pulse-rate"
                                    placeholder="Ex. 200"
                                    v-model="step[6].pulseRate"
                                    :class="{
                                        'is-invalid': v$.step[6].pulseRate.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].pulseRate.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Respiratory Rate (bpm)</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="respiratory-rate"
                                    placeholder="Ex. 20"
                                    v-model="step[6].respiratoryRate"
                                    :class="{
                                        'is-invalid': v$.step[6].respiratoryRate.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[6].respiratoryRate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Temperature (C)</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="temperature"
                                    placeholder="Ex. 36"
                                    v-model="step[6].temperature"
                                    :class="{
                                        'is-invalid': v$.step[6].temperature.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[6].temperature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Oxygen Saturation (%)</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="oxygen-saturation"
                                    placeholder="Ex. 100"
                                    v-model="step[6].oxygenSaturation"
                                    :class="{
                                        'is-invalid': v$.step[6].oxygenSaturation.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[6].oxygenSaturation.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Blood Sugar Level (mmol)</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="blood-sugar-level"
                                    placeholder="Ex. 10"
                                    v-model="step[6].bloodSugarLevel"
                                    :class="{
                                        'is-invalid': v$.step[6].bloodSugarLevel.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[6].bloodSugarLevel.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Special Treatment</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="special-treatment"
                                    placeholder="Treatment Details"
                                    v-model="step[6].specialTreatment"
                                    :class="{
                                        'is-invalid': v$.step[6].specialTreatment.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[6].specialTreatment.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">RN's Signature</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="rn-signature"
                                    placeholder="Enter your full name"
                                    v-model="step[6].RNSignature"
                                    :class="{
                                        'is-invalid': v$.step[6].RNSignature.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[6].RNSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 8" title="Resident Belongings">
                <div class="card-header">
                    <h3 class="card-title">Resident Belongings</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-12 col-md-4 col-xl-4">
                            <div class="mb-3">
                                <div class="form-label">Dress</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="dress"
                                        v-model="step[7].dress"
                                        :class="{
                                            'is-invalid': v$.step[7].dress.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="dress-new" v-model="step[7].dressNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].dress.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].dressNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Cardigan</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="cardigan"
                                        v-model="step[7].cardigan"
                                        :class="{
                                            'is-invalid': v$.step[7].cardigan.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="cardigan-new" v-model="step[7].cardiganNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].cardigan.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].cardiganNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Singlet</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="singlet"
                                        v-model="step[7].singlet"
                                        :class="{
                                            'is-invalid': v$.step[7].singlet.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="singlet-new" v-model="step[7].singletNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].singlet.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].singletNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Underpants</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="underpants"
                                        v-model="step[7].underpants"
                                        :class="{
                                            'is-invalid': v$.step[7].underpants.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="underpants-new" v-model="step[7].underpantsNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].underpants.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].underpantsNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Pajamas</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="pajamas"
                                        v-model="step[7].pajamas"
                                        :class="{
                                            'is-invalid': v$.step[7].pajamas.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="pajamas-new" v-model="step[7].pajamasNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].pajamas.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].pajamasNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Nighties</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="nighties"
                                        v-model="step[7].nighties"
                                        :class="{
                                            'is-invalid': v$.step[7].nighties.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="nighties-new" v-model="step[7].nightiesNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].nighties.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].nightiesNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Dressing gown</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="dressing-gown"
                                        v-model="step[7].dressingGown"
                                        :class="{
                                            'is-invalid': v$.step[7].dressingGown.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="dressing-gown-new" v-model="step[7].dressingGownNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].dressingGown.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].dressingGownNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Jewelries</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="jewelries"
                                        v-model="step[7].jewelries"
                                        :class="{
                                            'is-invalid': v$.step[7].jewelries.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="jewelries-new" v-model="step[7].jewelriesNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].jewelries.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].jewelriesNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 col-xl-4">
                            <div class="mb-3">
                                <div class="form-label">Shoes</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="shoes"
                                        v-model="step[7].shoes"
                                        :class="{
                                            'is-invalid': v$.step[7].shoes.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="shoes-new" v-model="step[7].shoesNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].shoes.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].shoesNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Socks</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="socks"
                                        v-model="step[7].socks"
                                        :class="{
                                            'is-invalid': v$.step[7].socks.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="socks-new" v-model="step[7].socksNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].socks.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].socksNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Stockings</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="stockings"
                                        v-model="step[7].stockings"
                                        :class="{
                                            'is-invalid': v$.step[7].stockings.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="stockings-new" v-model="step[7].stockingsNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].stockings.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].stockingsNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Slippers</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="slippers"
                                        v-model="step[7].slippers"
                                        :class="{
                                            'is-invalid': v$.step[7].slippers.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="slippers-new" v-model="step[7].slippersNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].slippers.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].slippersNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Jerseys</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="jerseys"
                                        v-model="step[7].jerseys"
                                        :class="{
                                            'is-invalid': v$.step[7].jerseys.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="jerseys-new" v-model="step[7].jerseysNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].jerseys.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].jerseysNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Shirts</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="shirts"
                                        v-model="step[7].shirts"
                                        :class="{
                                            'is-invalid': v$.step[7].shirts.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="shirts-new" v-model="step[7].shirtsNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].shirts.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].shirtsNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Blouses</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="blouses"
                                        v-model="step[7].blouses"
                                        :class="{
                                            'is-invalid': v$.step[7].blouses.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="blouses-new" v-model="step[7].blousesNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].blouses.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].blousesNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Jackets</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="jackets"
                                        v-model="step[7].jackets"
                                        :class="{
                                            'is-invalid': v$.step[7].jackets.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="jackets-new" v-model="step[7].jacketsNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].jackets.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].jacketsNew.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 col-xl-4">
                            <div class="mb-3">
                                <div class="form-label">Skirts</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="skirts"
                                        v-model="step[7].skirts"
                                        :class="{
                                            'is-invalid': v$.step[7].skirts.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="skirts-new" v-model="step[7].skirtsNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].skirts.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].skirtsNew.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Hats</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="hats"
                                        v-model="step[7].hats"
                                        :class="{
                                            'is-invalid': v$.step[7].hats.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="hats-new" v-model="step[7].hatsNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].hats.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].hatsNew.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Shaver</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="shaver"
                                        v-model="step[7].shaver"
                                        :class="{
                                            'is-invalid': v$.step[7].shaver.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="shaver-new" v-model="step[7].shaverNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].shaver.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].shaverNew.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Hair Dryer</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="hair-dryer"
                                        v-model="step[7].hairDryer"
                                        :class="{
                                            'is-invalid': v$.step[7].hairDryer.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="hair-dryer-new" v-model="step[7].hairDryerNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].hairDryer.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].hairDryerNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Radio</div>
                                <div class="d-flex align-items-center">
                                    <select
                                        class="form-select w-50"
                                        name="radio"
                                        v-model="step[7].radio"
                                        :class="{
                                            'is-invalid': v$.step[7].radio.$invalid,
                                        }"
                                    >
                                        <option v-for="(n, i) in belongingsMaxCount + 1" :value="i">
                                            {{ i }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="radio-new" v-model="step[7].radioNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].radio.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].radioNew.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">TV</div>
                                <div class="d-flex align-items-center">
                                    <select class="form-select w-50" name="tv" v-model="step[7].tv" :class="{'is-invalid': v$.step[7].tv.$invalid}">
                                        <option v-for="option in yesNoOptions" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="tv-new" v-model="step[7].tvNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].tv.$invalid}">Invalid feedback</div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].tvNew.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Furniture</div>
                                <div class="d-flex align-items-center">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="furniture"
                                        placeholder="Short Description"
                                        v-model="step[7].furniture"
                                        :class="{
                                            'is-invalid': v$.step[7].furniture.$invalid,
                                        }"
                                    />
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="furniture-new" v-model="step[7].furnitureNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].furniture.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].furnitureNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Other Belonging</div>
                                <div class="d-flex align-items-center">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="other-belonging"
                                        placeholder="Short Description"
                                        v-model="step[7].otherBelonging"
                                        :class="{
                                            'is-invalid': v$.step[7].otherBelonging.$invalid,
                                        }"
                                    />
                                    <div class="form-check form-switch mb-0 ms-3">
                                        <input class="form-check-input" type="checkbox" name="other-belonging-new" v-model="step[7].otherBelongingNew" />
                                        <span class="form-check-label">New</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].otherBelonging.$invalid}">Invalid feedback</div>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[7].otherBelongingNew.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 9" title="Resident Belongings">
                <div class="card-header">
                    <h3 class="card-title">Resident Belongings</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Checked that all items are named?</div>
                                <label v-for="option in yesNoOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[8].checkedAllItems" name="checked-all-items" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[8].checkedAllItems.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Inventory Personnel Signature</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="inventory-personnel-signature"
                                    placeholder="Enter your full name"
                                    v-model="step[8].inventoryPersonnelSignature"
                                    :class="{
                                        'is-invalid': v$.step[8].inventoryPersonnelSignature.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[8].inventoryPersonnelSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Family Member's Signature</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="family-signature"
                                    placeholder="Ask family member to enter full name"
                                    v-model="step[8].familySignature"
                                    :class="{
                                        'is-invalid': v$.step[8].familySignature.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[8].familySignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6"></div>
                    </div>
                </div>

                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="" id="save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3" id="back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, decimal, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";

// Custom Validators
const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
const isDateFormat = (value) => value.match("((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s\'\"]*$") || !helpers.req(value);
const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);

export default {
    name: "residentCreateComponent",
    props: ["progressBar", "pageTitle", "userId", "resident", "operation", "rooms", "photo"], // vue can read kebab props as camel cased vars

    setup() {
        return {v$: useVuelidate()};
    },
    data() {
        var ethnicities = ["European", "Maori", "Pacific Peoples", "Asian", "African", "Middle Eastern", "Latin American", "Other"];
        var religions = ["Buddhist", "Christian", "Hindu", "Jewish", "Muslim", "Sikh", "No religion", "Other"];
        var roomIDs = [];

        for (const entry of JSON.parse(this.rooms)) {
            roomIDs.push(entry.id);
        }

        // If editing, assign resident object to a variable
        if (this.operation == "store") {
            var residentObject = {};
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/residents/" + process.env.MIX_API_KEY;
        } else if (this.operation == "update") {
            var residentObject = JSON.parse(this.resident);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/residents/" + residentObject.id + "/" + process.env.MIX_API_KEY;
        }

        // Return empty string when object doesn't exist
        // options - array | string
        function returnValueFromObject(fieldName, fieldType, defaultValue = "", options) {
            // Editing
            if (!_.isEmpty(residentObject)) {
                if (fieldType == "Select With Other") {
                    if (!options.includes(residentObject[fieldName])) {
                        return "Other";
                    } else {
                        return residentObject[fieldName];
                    }
                } else if (fieldType == "Timestamp") {
                    residentObject[fieldName] = residentObject[fieldName] != null ? residentObject[fieldName].split(" ")[0] : null; //get the date only
                    return residentObject[fieldName];
                } else if (fieldType == "Boolean") {
                    if (residentObject[fieldName]) {
                        return "Yes";
                    } else {
                        return "No";
                    }
                } else if (fieldType == "JSON") {
                    if (fieldName == "resident_belongings") {
                        var field = options.split("|");
                        // if field has value and condition fields
                        if (field.length > 1) {
                            return JSON.parse(residentObject[fieldName])[field[0]][field[1]];
                        }
                        // if field only has value
                        else {
                            return JSON.parse(residentObject[fieldName])[field[0]];
                        }
                    } else {
                        return JSON.parse(residentObject[fieldName])[options];
                    }
                } else {
                    return residentObject[fieldName];
                }
            }
            // Creating
            else {
                return defaultValue;
            }
        }

        return {
            currentStep: 1,
            maxStep: 9,
            percentageComplete: 0,
            errors: 0,
            maritalStatusOptions: ["Single", "De Facto", "Married", "Widowed", "Divorced", "Separated"],
            genderOptions: ["Male", "Female"],
            ethnicityOptions: ethnicities,
            religionOptions: religions,
            roomOptions: JSON.parse(this.rooms),
            roomIDOptions: roomIDs,
            yesNoOptions: ["Yes", "No"],
            trueFalseOptions: [true, false],
            relationshipOptions: [
                "Mother",
                "Father",
                "Daughter",
                "Son",
                "Sister",
                "Brother",
                "Aunt",
                "Uncle",
                "Niece",
                "Nephew",
                "Cousin (female)",
                "Cousin (male)",
                "Grandmother",
                "Grandfather",
                "Granddaughter",
                "Grandson",
                "Stepsister",
                "Stepbrother",
                "Stepmother",
                "Stepfather",
                "Stepdaughter",
                "Stepson",
                "Sister-in-law",
                "Brother-in-law",
                "Mother-in-law",
                "Father-in-law",
                "Daughter-in-law",
                "Guardian",
                "Husband",
                "Wife",
                "Other",
            ],
            funeralArrangementOptions: ["Burial", "Cremation"],
            belongingsMaxCount: 10,
            endpoint: endpointToUse,
            editPhotoLink: "/residents/" + JSON.parse(this.resident).id + "/edit-photo",
            step: [
                // Step 1
                {
                    givenName: returnValueFromObject("first_name"),
                    preferredName: returnValueFromObject("preferred_name"),
                    surname: returnValueFromObject("last_name"),
                    NHINumber: returnValueFromObject("nhi_number"),
                    dateOfBirth: returnValueFromObject("date_of_birth", "Timestamp", "1975-01-02"), // 1975-01-02 'YYYY-MM-DD' mysql date format  or //new Date().toISOString().slice(0,10)
                    birthPlace: returnValueFromObject("place_of_birth"),
                    maritalStatus: returnValueFromObject("marital_status"),
                    gender: returnValueFromObject("gender"),
                    iwi: returnValueFromObject("iwi"),
                    ethnicity: returnValueFromObject("ethnicity", "Select With Other", "", ethnicities),
                    ethnicityOther: returnValueFromObject("ethnicity", "Select With Other", "", ethnicities) == "Other" ? residentObject["ethnicity"] : "", // Show the 'other' value
                    religion: returnValueFromObject("religion", "Select With Other", "", religions),
                    religionOther: returnValueFromObject("religion", "Select With Other", "", religions) == "Other" ? residentObject["religion"] : "", // Show the 'other' value
                },
                // Step 2
                {
                    admissionDate: returnValueFromObject("admission_date", "Timestamp", new Date().toISOString().slice(0, 10)),
                    roomID: returnValueFromObject("room_id"),
                    admittedFrom: returnValueFromObject("admitted_from"),
                    referredBy: returnValueFromObject("referred_by"),
                    assessmentDate: returnValueFromObject("assessment_date", "Timestamp"),
                    assessedBy: returnValueFromObject("assessed_by"),
                    assessedByPhone: returnValueFromObject("assessed_by_phone"),
                    socialWorker: returnValueFromObject("social_worker"),
                    socialWorkerPhone: returnValueFromObject("social_worker_phone"),
                    previousGP: returnValueFromObject("previous_gp"),
                    previousGPPhone: returnValueFromObject("previous_gp_phone"),
                    houseGP: returnValueFromObject("house_gp"),
                    houseGPPhone: returnValueFromObject("house_gp_phone"),
                    resuscitation: returnValueFromObject("resuscitation", "Boolean"),
                },
                // Step 3
                {
                    namePropertyEPOA: returnValueFromObject("epoas", "JSON", "", "name-property-epoa"),
                    relationshipPropertyEPOA: returnValueFromObject("epoas", "JSON", "", "relationship-property-epoa"),
                    relationshipPropertyEPOAOther: returnValueFromObject("epoas", "JSON", "", "relationship-property-epoa-other"),
                    addressPropertyEPOA: returnValueFromObject("epoas", "JSON", "", "address-property-epoa"),
                    phonePropertyEPOA: returnValueFromObject("epoas", "JSON", "", "phone-property-epoa"),
                    mobilePropertyEPOA: returnValueFromObject("epoas", "JSON", "", "mobile-property-epoa"),
                    emailPropertyEPOA: returnValueFromObject("epoas", "JSON", "", "email-property-epoa"),
                    nameWelfareEPOA: returnValueFromObject("epoas", "JSON", "", "name-welfare-epoa"),
                    relationshipWelfareEPOA: returnValueFromObject("epoas", "JSON", "", "relationship-welfare-epoa"),
                    relationshipWelfareEPOAOther: returnValueFromObject("epoas", "JSON", "", "relationship-welfare-epoa-other"),
                    addressWelfareEPOA: returnValueFromObject("epoas", "JSON", "", "address-welfare-epoa"),
                    phoneWelfareEPOA: returnValueFromObject("epoas", "JSON", "", "phone-welfare-epoa"),
                    mobileWelfareEPOA: returnValueFromObject("epoas", "JSON", "", "mobile-welfare-epoa"),
                    emailWelfareEPOA: returnValueFromObject("epoas", "JSON", "", "email-welfare-epoa"),
                },
                // Step 4
                {
                    nameKin1: returnValueFromObject("kins", "JSON", "", "name-kin1"),
                    relationshipKin1: returnValueFromObject("kins", "JSON", "", "relationship-kin1"),
                    relationshipKin1Other: returnValueFromObject("kins", "JSON", "", "relationship-kin1-other"),
                    addressKin1: returnValueFromObject("kins", "JSON", "", "address-kin1"),
                    phoneKin1: returnValueFromObject("kins", "JSON", "", "phone-kin1"),
                    mobileKin1: returnValueFromObject("kins", "JSON", "", "mobile-kin1"),
                    emailKin1: returnValueFromObject("kins", "JSON", "", "email-kin1"),
                    nameKin2: returnValueFromObject("kins", "JSON", "", "name-kin2"),
                    relationshipKin2: returnValueFromObject("kins", "JSON", "", "relationship-kin2"),
                    relationshipKin2Other: returnValueFromObject("kins", "JSON", "", "relationship-kin2-other"),
                    addressKin2: returnValueFromObject("kins", "JSON", "", "address-kin2"),
                    phoneKin2: returnValueFromObject("kins", "JSON", "", "phone-kin2"),
                    mobileKin2: returnValueFromObject("kins", "JSON", "", "mobile-kin2"),
                    emailKin2: returnValueFromObject("kins", "JSON", "", "email-kin2"),
                },
                // Step 5
                {
                    nameAccountManager: returnValueFromObject("account_manager", "JSON", "", "name-account-manager"),
                    communityCardNumber: returnValueFromObject("account_manager", "JSON", "", "community-card-number"),
                    communityCardExpiryDate: returnValueFromObject("account_manager", "JSON", "", "community-card-expiry-date"),
                    sectionedUnderMentalHealth: returnValueFromObject("funeral_arrangements", "JSON", "", "sectioned-under-mental-health"),
                    funeralArrangement: returnValueFromObject("funeral_arrangements", "JSON", "", "funeral-arrangement"),
                    nameFuneralDirector: returnValueFromObject("funeral_arrangements", "JSON", "", "name-funeral-director"),
                    specialRequirements: returnValueFromObject("funeral_arrangements", "JSON", "", "special-requirements"),
                    arrangementsToBeMade: returnValueFromObject("funeral_arrangements", "JSON", "", "arrangements-to-be-made"),
                    dischargeDate: returnValueFromObject("funeral_arrangements", "JSON", "", "discharge-date"),
                    dischargeTo: returnValueFromObject("funeral_arrangements", "JSON", "", "discharge-to"),
                    medicalNotesTransferred: returnValueFromObject("funeral_arrangements", "JSON", "", "medical-notes-transferred"),
                    relevantPagesCopiedArchived: returnValueFromObject("funeral_arrangements", "JSON", "", "relevant-pages-copied-archived"),
                },
                // Step 6
                {
                    previousMedicalHistory: returnValueFromObject("medical_history", "JSON", "", "previous-medical-history"),
                    currentMedicalProblems: returnValueFromObject("medical_history", "JSON", "", "current-medical-problems"),
                    medicationOnAdmission: returnValueFromObject("medical_history", "JSON", "", "medication-on-admission"),
                    allergies: returnValueFromObject("medical_history", "JSON", "", "allergies"),
                },
                // Step 7
                {
                    height: returnValueFromObject("baseline_observations", "JSON", "", "height"),
                    weight: returnValueFromObject("baseline_observations", "JSON", "", "weight"),
                    bloodPressure: returnValueFromObject("baseline_observations", "JSON", "", "blood-pressure"),
                    bloodPressureOver: returnValueFromObject("baseline_observations", "JSON", "", "blood-pressure-over"),
                    pulseRate: returnValueFromObject("baseline_observations", "JSON", "", "pulse-rate"),
                    respiratoryRate: returnValueFromObject("baseline_observations", "JSON", "", "respiratory-rate"),
                    temperature: returnValueFromObject("baseline_observations", "JSON", "", "temperature"),
                    oxygenSaturation: returnValueFromObject("baseline_observations", "JSON", "", "oxygen-saturation"),
                    bloodSugarLevel: returnValueFromObject("baseline_observations", "JSON", "", "blood-sugar-level"),
                    specialTreatment: returnValueFromObject("baseline_observations", "JSON", "", "special-treatment"),
                    RNSignature: returnValueFromObject("baseline_observations", "JSON", "", "rn-signature"),
                },
                // Step 8
                {
                    dress: returnValueFromObject("resident_belongings", "JSON", "0", "dress|value"),
                    cardigan: returnValueFromObject("resident_belongings", "JSON", "0", "cardigan|value"),
                    singlet: returnValueFromObject("resident_belongings", "JSON", "0", "singlet|value"),
                    underpants: returnValueFromObject("resident_belongings", "JSON", "0", "underpants|value"),
                    pajamas: returnValueFromObject("resident_belongings", "JSON", "0", "pajamas|value"),
                    nighties: returnValueFromObject("resident_belongings", "JSON", "0", "nighties|value"),
                    dressingGown: returnValueFromObject("resident_belongings", "JSON", "0", "dressing-gown|value"),
                    jewelries: returnValueFromObject("resident_belongings", "JSON", "0", "jewelries|value"),
                    shoes: returnValueFromObject("resident_belongings", "JSON", "0", "shoes|value"),
                    socks: returnValueFromObject("resident_belongings", "JSON", "0", "socks|value"),
                    stockings: returnValueFromObject("resident_belongings", "JSON", "0", "stockings|value"),
                    slippers: returnValueFromObject("resident_belongings", "JSON", "0", "slippers|value"),
                    jerseys: returnValueFromObject("resident_belongings", "JSON", "0", "jerseys|value"),
                    shirts: returnValueFromObject("resident_belongings", "JSON", "0", "shirts|value"),
                    blouses: returnValueFromObject("resident_belongings", "JSON", "0", "blouses|value"),
                    jackets: returnValueFromObject("resident_belongings", "JSON", "0", "jackets|value"),
                    skirts: returnValueFromObject("resident_belongings", "JSON", "0", "skirts|value"),
                    hats: returnValueFromObject("resident_belongings", "JSON", "0", "hats|value"),
                    shaver: returnValueFromObject("resident_belongings", "JSON", "0", "shaver|value"),
                    hairDryer: returnValueFromObject("resident_belongings", "JSON", "0", "hair-dryer|value"),
                    radio: returnValueFromObject("resident_belongings", "JSON", "0", "radio|value"),
                    tv: returnValueFromObject("resident_belongings", "JSON", "No", "tv|value"),
                    furniture: returnValueFromObject("resident_belongings", "JSON", "", "furniture|value"),
                    otherBelonging: returnValueFromObject("resident_belongings", "JSON", "", "other-belonging|value"),

                    dressNew: returnValueFromObject("resident_belongings", "JSON", false, "furniture|condition"),
                    cardiganNew: returnValueFromObject("resident_belongings", "JSON", false, "cardigan|condition"),
                    singletNew: returnValueFromObject("resident_belongings", "JSON", false, "singlet|condition"),
                    underpantsNew: returnValueFromObject("resident_belongings", "JSON", false, "underpants|condition"),
                    pajamasNew: returnValueFromObject("resident_belongings", "JSON", false, "pajamas|condition"),
                    nightiesNew: returnValueFromObject("resident_belongings", "JSON", false, "nighties|condition"),
                    dressingGownNew: returnValueFromObject("resident_belongings", "JSON", false, "dressing-gown|condition"),
                    jewelriesNew: returnValueFromObject("resident_belongings", "JSON", false, "jewelries|condition"),
                    shoesNew: returnValueFromObject("resident_belongings", "JSON", false, "shoes|condition"),
                    socksNew: returnValueFromObject("resident_belongings", "JSON", false, "socks|condition"),
                    stockingsNew: returnValueFromObject("resident_belongings", "JSON", false, "stockings|condition"),
                    slippersNew: returnValueFromObject("resident_belongings", "JSON", false, "slippers|condition"),
                    jerseysNew: returnValueFromObject("resident_belongings", "JSON", false, "jerseys|condition"),
                    shirtsNew: returnValueFromObject("resident_belongings", "JSON", false, "shirts|condition"),
                    blousesNew: returnValueFromObject("resident_belongings", "JSON", false, "blouses|condition"),
                    jacketsNew: returnValueFromObject("resident_belongings", "JSON", false, "jackets|condition"),
                    skirtsNew: returnValueFromObject("resident_belongings", "JSON", false, "skirts|condition"),
                    hatsNew: returnValueFromObject("resident_belongings", "JSON", false, "hats|condition"),
                    shaverNew: returnValueFromObject("resident_belongings", "JSON", false, "shaver|condition"),
                    hairDryerNew: returnValueFromObject("resident_belongings", "JSON", false, "hair-dryer|condition"),
                    radioNew: returnValueFromObject("resident_belongings", "JSON", false, "radio|condition"),
                    tvNew: returnValueFromObject("resident_belongings", "JSON", false, "tv|condition"),
                    furnitureNew: returnValueFromObject("resident_belongings", "JSON", false, "furniture|condition"),
                    otherBelongingNew: returnValueFromObject("resident_belongings", "JSON", false, "other-belonging|condition"),
                },
                // Step 9
                {
                    checkedAllItems: returnValueFromObject("resident_belongings", "JSON", "", "checked-all-items"),
                    inventoryPersonnelSignature: returnValueFromObject("resident_belongings", "JSON", "", "inventory-personnel-signature"),
                    familySignature: returnValueFromObject("resident_belongings", "JSON", "", "family-signature"),
                },
            ],
        };
    },
    validations() {
        const dateType = {
            required,
            isDateFormat,
            $lazy: true,
            $autoDirty: true,
        };
        const phoneType = {
            required,
            integer,
            minLength: minLength(10),
            $lazy: true,
            $autoDirty: true,
        };
        const emailType = {
            required,
            email,
            minLength: minLength(5),
            $lazy: true,
            $autoDirty: true,
        };
        const alphaNumType = {
            required,
            alphaNum,
            minLength: minLength(3),
            $lazy: true,
            $autoDirty: true,
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3, maximum = 191, isRequired = false) {
            var rule = {
                required,
                isTextWithSpecialCharacters,
                minLength: minLength(minimum),
                maxLength: maxLength(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // INT TYPES:
        function intType(minimum = 0, maximum = 10, isRequired = false) {
            var rule = {
                required,
                integer,
                minValue: minValue(minimum),
                maxValue: maxValue(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // DECIMAL TYPES:
        function decimalType(minimum = 0, maximum = 10, isRequired = false) {
            var rule = {
                required,
                decimal,
                minValue: minValue(minimum),
                maxValue: maxValue(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // ARRAY TYPES
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);
            delete validations["required"];

            return validations;
        }

        return {
            step: [
                //Step 1
                {
                    givenName: text(3, 191, true),
                    preferredName: text(3, 191, true),
                    surname: text(3, 191, true),
                    NHINumber: alphaNumType,
                    dateOfBirth: dateType,
                    birthPlace: alphaNumType,
                    maritalStatus: inOptions(this.maritalStatusOptions, true),
                    gender: inOptions(this.genderOptions, true),
                    iwi: notRequired(alphaNumType),
                    ethnicity: inOptions(this.ethnicityOptions, true),
                    ethnicityOther: {
                        required: requiredIf(function () {
                            return this.step[0].ethnicity === "Other" ? true : false;
                        }),
                        alpha,
                        minLength: minLength(3),
                        $lazy: true,
                        $autoDirty: true,
                    },
                    religion: inOptions(this.religionOptions, true),
                    religionOther: {
                        required: requiredIf(function () {
                            return this.step[0].religion === "Other" ? true : false;
                        }),
                        alpha,
                        minLength: minLength(3),
                        $lazy: true,
                        $autoDirty: true,
                    },
                },
                //Step 2
                {
                    admissionDate: dateType,
                    roomID: inOptions(this.roomIDOptions, true),
                    admittedFrom: text(3, 191, true),
                    referredBy: text(),
                    assessmentDate: notRequired(dateType),
                    assessedBy: text(),
                    assessedByPhone: notRequired(phoneType),
                    socialWorker: text(),
                    socialWorkerPhone: notRequired(phoneType),
                    previousGP: text(),
                    previousGPPhone: notRequired(phoneType),
                    houseGP: text(),
                    houseGPPhone: notRequired(phoneType),
                    resuscitation: inOptions(this.yesNoOptions, true),
                },
                //Step 3
                {
                    namePropertyEPOA: text(),
                    relationshipPropertyEPOA: inOptions(this.relationshipOptions),
                    relationshipPropertyEPOAOther: text(),
                    addressPropertyEPOA: text(),
                    phonePropertyEPOA: notRequired(phoneType),
                    mobilePropertyEPOA: notRequired(phoneType),
                    emailPropertyEPOA: notRequired(emailType),
                    nameWelfareEPOA: text(),
                    relationshipWelfareEPOA: inOptions(this.relationshipOptions),
                    relationshipWelfareEPOAOther: text(),
                    addressWelfareEPOA: text(),
                    phoneWelfareEPOA: notRequired(phoneType),
                    mobileWelfareEPOA: notRequired(phoneType),
                    emailWelfareEPOA: notRequired(emailType),
                },
                //Step 4
                {
                    nameKin1: text(),
                    relationshipKin1: inOptions(this.relationshipOptions),
                    relationshipKin1Other: text(),
                    addressKin1: text(),
                    phoneKin1: notRequired(phoneType),
                    mobileKin1: notRequired(phoneType),
                    emailKin1: notRequired(emailType),
                    nameKin2: text(),
                    relationshipKin2: inOptions(this.relationshipOptions),
                    relationshipKin2Other: text(),
                    addressKin2: text(),
                    phoneKin2: notRequired(phoneType),
                    mobileKin2: notRequired(phoneType),
                    emailKin2: notRequired(emailType),
                },
                //Step 5
                {
                    nameAccountManager: text(),
                    communityCardNumber: notRequired(alphaNumType),
                    communityCardExpiryDate: notRequired(dateType),
                    sectionedUnderMentalHealth: inOptions(this.yesNoOptions),
                    funeralArrangement: inOptions(this.funeralArrangementOptions),
                    nameFuneralDirector: text(),
                    specialRequirements: text(),
                    arrangementsToBeMade: text(),
                    dischargeDate: notRequired(dateType),
                    dischargeTo: text(),
                    medicalNotesTransferred: inOptions(this.yesNoOptions),
                    relevantPagesCopiedArchived: inOptions(this.yesNoOptions),
                },
                //Step 6
                {
                    previousMedicalHistory: text(3, 1000, true),
                    currentMedicalProblems: text(3, 1000, true),
                    medicationOnAdmission: text(3, 1000, true),
                    allergies: text(3, 1000, true),
                },
                // Step 7
                {
                    height: decimalType(0, 300, true),
                    weight: decimalType(0, 300, true),
                    bloodPressure: decimalType(0, 300, true),
                    bloodPressureOver: decimalType(0, 300, true),
                    pulseRate: decimalType(0, 300, true),
                    respiratoryRate: decimalType(0, 300, true),
                    temperature: decimalType(0, 300, true),
                    oxygenSaturation: decimalType(0, 300, true),
                    bloodSugarLevel: decimalType(0, 300, true),
                    specialTreatment: text(3, 191),
                    RNSignature: text(3, 191, true),
                },
                // Step 8
                {
                    dress: intType(0, 10),
                    cardigan: intType(0, 10),
                    singlet: intType(0, 10),
                    underpants: intType(0, 10),
                    pajamas: intType(0, 10),
                    nighties: intType(0, 10),
                    dressingGown: intType(0, 10),
                    jewelries: intType(0, 10),
                    shoes: intType(0, 10),
                    socks: intType(0, 10),
                    stockings: intType(0, 10),
                    slippers: intType(0, 10),
                    jerseys: intType(0, 10),
                    shirts: intType(0, 10),
                    blouses: intType(0, 10),
                    jackets: intType(0, 10),
                    skirts: intType(0, 10),
                    hats: intType(0, 10),
                    shaver: intType(0, 10),
                    hairDryer: intType(0, 10),
                    radio: intType(0, 10),
                    tv: inOptions(this.yesNoOptions),
                    furniture: text(),
                    otherBelonging: text(),

                    dressNew: inOptions(this.trueFalseOptions),
                    cardiganNew: inOptions(this.trueFalseOptions),
                    singletNew: inOptions(this.trueFalseOptions),
                    underpantsNew: inOptions(this.trueFalseOptions),
                    pajamasNew: inOptions(this.trueFalseOptions),
                    nightiesNew: inOptions(this.trueFalseOptions),
                    dressingGownNew: inOptions(this.trueFalseOptions),
                    jewelriesNew: inOptions(this.trueFalseOptions),
                    shoesNew: inOptions(this.trueFalseOptions),
                    socksNew: inOptions(this.trueFalseOptions),
                    stockingsNew: inOptions(this.trueFalseOptions),
                    slippersNew: inOptions(this.trueFalseOptions),
                    jerseysNew: inOptions(this.trueFalseOptions),
                    shirtsNew: inOptions(this.trueFalseOptions),
                    blousesNew: inOptions(this.trueFalseOptions),
                    jacketsNew: inOptions(this.trueFalseOptions),
                    skirtsNew: inOptions(this.trueFalseOptions),
                    hatsNew: inOptions(this.trueFalseOptions),
                    shaverNew: inOptions(this.trueFalseOptions),
                    hairDryerNew: inOptions(this.trueFalseOptions),
                    radioNew: inOptions(this.trueFalseOptions),
                    tvNew: inOptions(this.trueFalseOptions),
                    furnitureNew: inOptions(this.trueFalseOptions),
                    otherBelongingNew: inOptions(this.trueFalseOptions),
                },
                // Step 9
                {
                    checkedAllItems: inOptions(this.yesNoOptions),
                    inventoryPersonnelSignature: text(3, 191, true),
                    familySignature: text(3, 191, true),
                },
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {
                if (this.currentStep < this.maxStep) {
                    // Proceed to next step
                    this.currentStep++;
                } else if (this.currentStep == this.maxStep) {
                    // Initialize alerts and toast notifications for displaying message
                    const toastError = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: true,
                    });
                    const alertSuccess = Swal.mixin({
                        position: "center",
                        showConfirmButton: true,
                        timer: 3000,
                        timerProgressBar: true,
                    });

                    // Show button spinner
                    document.getElementById("submit-btn").innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById("submit-btn").disabled = true;
                    document.getElementById("back-btn").style.display = "none";
                    document.getElementById("save-btn").style.display = "none";

                    // Loop through all fields
                    const formData = {};
                    for (let i = 0; i < this.maxStep; i++) {
                        for (const [key, value] of Object.entries(this.step[i])) {
                            // formData.append(key, value);
                            formData[key] = value;

                            // convert "Yes/No" values to boolean
                            if (key == "resuscitation") {
                                formData[key] = value == "Yes" ? true : false;
                            }
                        }
                    }

                    // Add userID
                    formData["userID"] = this.userId;

                    if (this.operation == "store") {
                        this.createResident(formData, toastError, alertSuccess);
                    } else if (this.operation == "update") {
                        this.updateResident(formData, toastError, alertSuccess);
                    }
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },

        onClickBack: function () {
            if (this.currentStep > 1) {
                this.currentStep--;
            }
            this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
        },

        createResident: function (formData, toastError, alertSuccess) {
            // Call the store endpoint
            axios
                .post(this.endpoint, formData)
                .then((response) => {
                    if (response.data.error == 403) {
                        console.log("Bad Request");
                        console.log(response.data);

                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({
                            type: "warning",
                            title: "The input fields are malformed and cant be processed.",
                        });
                    } else {
                        if (response.data.id == null) {
                            console.log("Validation Error");
                            console.log(response.data);

                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({
                                type: "warning",
                                title: "There are validation errors found on the form.",
                            });
                        } else {
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was added to the DB. Thi
                            this.formSuccess = true;
                            alertSuccess
                                .fire({
                                    title: "Success!",
                                    text: "The resident has been added.",
                                    icon: "success",
                                })
                                .then(function () {
                                    window.location = "/residents";
                                });
                        }
                    }
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({type: "error", title: "Sorry, request failed to submit."}); // this error occurs when endpoint is wrong
                });
        },

        updateResident: function (formData, toastError, alertSuccess) {
            // Call the update endpoint
            axios
                .put(this.endpoint, formData)
                .then((response) => {
                    if (response.data.error == 403) {
                        console.log("Bad Request");
                        console.log(response.data);

                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({
                            type: "warning",
                            title: "The input fields are malformed and cant be processed.",
                        });
                    } else {
                        if (response.data.id == null) {
                            console.log("Validation Error");
                            console.log(response.data);

                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({
                                type: "warning",
                                title: "There are validation errors found on the form.",
                            });
                        } else {
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was updated
                            this.formSuccess = true;
                            alertSuccess
                                .fire({
                                    title: "Success!",
                                    text: "The resident has been updated.",
                                    icon: "success",
                                })
                                .then(function () {
                                    window.location = "/residents";
                                });
                        }
                    }
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({type: "error", title: "Sorry, request failed to submit."}); // this error occurs when endpoint is wrong
                });
        },
    },
};
</script>
